export const b2bArbitrageCreateTranslations = {
  steps: {
    funds: 'Funds',
    confirmation: 'Confirmation',
  },
  actions: {
    success: 'Arbitrage requested: it is created once another operator approves it',
    failure: 'Failed to request the arbitrage: %{error}',
    full_position: 'Full position',
    add_allocation: 'Add a fund',
  },
  sections: {
    sources: 'Funds to sell',
    targets: 'Funds to buy',
    summary_confirmation: 'Summary and confirmation',
    confirmations: 'Confirmations',
    confirm_accuracy: 'I confirm the accuracy of the data.',
  },
  fields: {
    saving_plan_id: 'Plan',
    instrument: 'Fund',
    amount: 'Amount (€)',
    held: 'Held: %{amount}',
    total_sold: 'Total sold',
    total_bought: 'Total bought',
    notify_employee: 'Notify the employee',
    reason: 'Reason',
  },
  messages: {
    no_holdings: 'No position held on this plan',
    amounts_do_not_match: 'The total sold must equal the total bought.',
    managed_plan: 'Managed by the plan allocation',
    notify_employee_help:
      'Once the arbitrage is approved, the employee receives the arbitrage registered and executed emails, mentioning that the ops team made this change.',
  },
  errors: {
    explore_has_restrictions:
      'A restriction blocks this arbitrage: the employee is restricted on this product, a fund to sell is fully restricted, or a fund to buy is restricted for the chosen funds to sell or globally.',
    explore_mixed_tax_wrappers:
      'All the plans of an arbitrage must have the same tax wrapper: PEE and PERECO plans can not be mixed.',
    explore_duplicate_instrument_allocation:
      'A fund can only appear once among the funds to sell and once among the funds to buy, and can not be both sold and bought on the same plan.',
    explore_instrument_locked_for_plan: 'A fund to sell is locked in its plan.',
    explore_instrument_not_enabled_for_plan: 'A fund to buy is not enabled in the target plan.',
    explore_insufficient_shares: 'An amount to sell is higher than what the employee holds.',
    explore_amount_exceeds_vested: 'An amount to sell is higher than the available amount.',
    explore_below_minimum_order:
      'An amount is below the minimum: 10 €, unless it sells the whole position or is the only purchase.',
    explore_too_many_allocations: 'Below 10 €, the amount can only be bought into a single fund.',
    explore_amounts_do_not_match: 'The total sold must equal the total bought.',
    explore_multiple_pilote_allocation:
      'A managed (Pilote) plan can only be used once per arbitrage: sell from it or buy into it, not both, and not several.',
  },
  validation: {
    exceeds_position: 'The amount exceeds the position (%{max}).',
    below_minimum:
      'Minimum %{min}, unless the whole position is sold or this is the only purchase.',
  },
};
